import { css } from 'styled-system/css';
import { center, flex } from 'styled-system/patterns';

export const matchSpecialStyles = {
	event: flex({
		justifyContent: 'space-between',
	}),
	stats: css({
		w: '130px',
		mr: 'auto',
		mb: '0!',
	}),
	info: css({
		_mars: {
			p: '5px 3px',
			alignItems: 'center!',
		}
	}),
	teamInfo: flex({
		justifyContent: 'space-between',
		alignItems: 'center',
		borderTop: '1px solid {colors.black.5}',
		p: '3px 1px  3px 9px',
		gap: '6px',
		'&[data-open="false"]': {
			pr: '9px'
		}
	}),
	teams: flex({
		_mars: {
			flex: '1',
			flexDirection: 'column',
			justifyContent: 'center',
			// padding: '3px 6px 11px 9px',
			paddingBottom: '8px',
			gap: '6px',
			// w: '100%',
			cursor: 'pointer',
		}
	}),
	team: flex({
		_mars: {
			alignItems: 'flex-start',
			fontSize: '14px',
			wordBreak: 'break-word',
			justifyContent: 'space-between',
			lineHeight: '18px',
			// w: '100%',
			gap: '6px',
		}
	}),
	teamName: css({
		_mars: {
			alignItems: 'flex-start',
			// height: 'inherit'
		}
	}),
	score: css({
		_mars: {
			color: 'secondary.500',
			fontWeight: 700,
			whiteSpace: 'nowrap',
		},
	}),
	scoreDisabled: css({
		_mars: {
			color: 'black.2',
			fontWeight: 700,
			whiteSpace: 'nowrap',
		}
	}),
	oddsTable: flex({
		_mars: {
			flex: '1 1 auto',
			flexDirection: 'column',
			overflow: 'hidden',
			position: 'relative',
			paddingBottom: '6px',
		}
	}),
	slideOddsTable: flex ({
		w: '100%',
		pb: '12px',
		'& .swiper': {
			w: '100%',
		},
		'& .swiper-slide': {
			minWidth: 'unset',
		},
		'--swiper-pagination-bottom': '2px',
		'& .swiper-pagination-bullet': {
			w: '4px',
			h: '4px',
			m: '0 2px',
			backgroundColor: 'black.3',
		},
		'& .swiper-pagination-bullet-active': {
			backgroundColor: 'brand.500',
		},
	}),
	bettypes: flex({
		_mars: {
			flex: 'none',
			// paddingBottom: '12px',
			minWidth: '100%',
			display: 'inline-flex',
			verticalAlign: 'top',
			position: 'relative',
			gap: '6px',		
		},
	}),
	bettype: css({
		_mars: {
			flex: '1',
			// padding: '0 2px',
			// width: '33.33%',
			// minWidth: '52px',
			gap: '6px',
		},
		'& .odds-button': {
			flexDirection: 'column',
			mb: '6px',
			h: '39px',
		},
		'& .odds-button__goal': {
			flex: 'none',
		},
		'& .odds-button__odds': {
			ml: '0',
			marginTop: '3px',
		},		
	}),
	bettypeTitle: center({
		_mars: {
			flex: '0 0 auto',
			marginBottom: '3px',
			padding: '0 6px',
			textAlign: 'center',
			p: '2px',
			backgroundColor: 'transparent',
			height: '30px',
			lineHeight: '1.2em',
			fontSize: '12px',
			color: 'bettypeTitle.text',
			whiteSpace: 'normal',
			// overflow: 'hidden',
			// textOverflow: 'ellipsis',
			// display: '-webkit-box',
			// WebkitLineClamp: '2',
			// boxOrient: 'vertical',
			paddingTop: '3px',
			'& .multi-line-ellipsis': {
				maxHeight: 'inherit',
				WebkitLineClamp: '2',
			}
		},
	}),
	moreline: flex({
		_mars: {
			flex: 'none',
			flexDirection: 'column',
			overflow: 'hidden',
			// whiteSpace: 'normal',
			minHeight: '39px',
			// fontSize: '12px',
			// color: 'black.1',
			boxShadow: 'inset 0 0 0 1px {colors.oddsTable.border}',
			bgColor: 'oddsTable.bg',
			borderRadius: '6px',
			p: '6px',
			gap: '6px',
			// textAlign: 'center',
			// cursor: 'pointer',
			pointerEvents: 'none',
			'&[data-open="true"]': {
				pointerEvents: 'auto',
				'& .btn-moreline': {
					display: 'none',
				}
			}
			
		}
	}),
	morelineBettypes: css({
		pb: '12px',
		'& .swiper-slide': {
			flex: 'none',
			w: 'auto',
			'& .odds-button': {
				minWidth: '108px',
			},		
		},
		'--swiper-pagination-bottom': '2px',
		'& .swiper-pagination-bullet': {
			w: '4px',
			h: '4px',
			m: '0 2px',
		}
	}),
	morelineOpenButton: center({
		_mars: {
			pointerEvents: 'auto',
			flex: 'none',
			whiteSpace: 'normal',
			height: '39px',
			fontSize: '12px',
			color: 'black.1',
			// boxShadow: 'inset 0 0 0 1px {colors.oddsTable.border}',
			// bgColor: 'oddsTable.bg',
			// borderRadius: '6px',
			p: '3px 6px',
			textAlign: 'center',
			cursor: 'pointer',
		}
	}),
	morelineCloseButton: center({
		_mars: {
			pos: 'relative',
			whiteSpace: 'normal',
			height: '24px',
			fontSize: '12px',
			color: 'brand.500',
			boxShadow: 'inset 0 0 0 1px {colors.brand.500}',
			bgColor: 'oddsTable.bg',
			borderRadius: '6px',
			p: '3px 6px',
			textAlign: 'center',
			cursor: 'pointer',
			'& .icon': {
				position: 'absolute',
				right: 0,
				color: 'brand.500',
				w: '18px',
				h: '18px',
				marginRight: '3px',
			}
		}
	}),
	iconButtons: css({
		flex: 'none!',
	}),
	matchContent: flex({
		_mars: {
			width: '100%',
			position: 'relative',
			overflow: 'hidden',
			flexDirection: 'column',
			p: '6px',
			'& .bettype': {
				ml: '-6px',
				mr: '-6px',
			},
			'& .bettype__header': {
				borderTopLeftRadius: '0',
				borderTopRightRadius: '0',
			},
			'& .bettype__content': {
				padding: '6px',
			}
		}
	}),
	// moreline: css({
	// 	flex: 'none',
	// }),
}